import { Map, Marker } from "@vis.gl/react-google-maps";
import { FC } from "react";

import WidgetContainer, {
  WidgetContainerProps,
} from "src/dynamic-view-renderer/Widgets/WidgetContainer.tsx";
import { Case } from "src/types/case";

import { GoogleMapsWidgetConfiguration } from "./GoogleMapsWidget";
import GoogleMapsWidgetError from "./GoogleMapsWidgetError";
import { useCompanyInfo } from "./useCompanyInfo";
import { useLocation } from "./useLocation";

export type GoogleMapsWidgetMapProps = Omit<WidgetContainerProps, "children"> & {
  data: {
    case: Case;
  };
  configuration?: GoogleMapsWidgetConfiguration;
};

const GoogleMapsWidgetMap: FC<GoogleMapsWidgetMapProps> = ({
  configuration,
  data,
  ...containerProps
}) => {
  const {
    defaultCenter = { lat: 22.54992, lng: 0 },
    defaultZoom = 5,
    height = "400px",
  } = configuration || {};

  const company = useCompanyInfo(data.case.elements, configuration);

  const { center, error } = useLocation({
    company,
    fallbackCenter: defaultCenter,
  });

  if (error) {
    return (
      <GoogleMapsWidgetError {...containerProps}>
        <div>{error}</div>
      </GoogleMapsWidgetError>
    );
  }

  return (
    <WidgetContainer {...containerProps}>
      <div style={{ height, width: "100%" }}>
        <Map
          style={{ width: "100%", height: "100%" }}
          center={center}
          zoom={defaultZoom}
          defaultCenter={defaultCenter}
          gestureHandling={"greedy"}
          disableDefaultUI={true}
          streetViewControl={false}
        >
          <Marker position={center} />
        </Map>
      </div>
    </WidgetContainer>
  );
};

export default GoogleMapsWidgetMap;
